import { useEffect } from "react";

import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useMyProfile } from "shared/api/useMyProfile";
import { alertDialog } from "shared/ui/feedback";

/**
 * 로그인 세션 유지 중 본인 권한이 관리자 미만(auth < 2)으로 강등된 경우를 감지해
 * 즉시 로그아웃시킨다.
 *
 * 다른 마스터관리자가 내 권한을 일반 사용자(auth 1)로 내리면, 토큰은 만료 전까지
 * 유효하므로 새로고침(또는 창 포커스) 시 myProfile 재조회로 auth=1이 확인된다.
 * 서버는 수정·삭제를 막지만 관리자 페이지 자체에는 여전히 진입되므로,
 * 프론트에서 세션을 끊어 접근을 원천 차단한다.
 * (모든 관리자 페이지를 감싸는 AdminLayout에서 렌더된다.)
 */
function EnforceManagerSession() {
  const { data, isSuccess } = useMyProfile();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (isSuccess && (data?.auth ?? 0) < 2) {
      localStorage.removeItem("admintoken");
      queryClient.clear();
      alertDialog("관리자 권한이 없어 로그아웃되었습니다.");
      navigate("/login", { replace: true });
    }
  }, [isSuccess, data, navigate, queryClient]);

  return null;
}

export default EnforceManagerSession;
